module.exports = __webpack_public_path__ + "img/supplement_T_8.c290945f.png";